__turbopack_context__.v({
  "className": "instrument_serif_712dec64-module__DwJa-W__className",
});
